import { useCallback, useState } from "react";
import { endPoints, getData } from "../utilities/networkCalls";
import {
    BundleBuilderConfigInterface,
    BuyNConfigInterface,
    BxgyConfigInterface,
    FBTConfigInterface,
    MixMatchConfigInterface,
    MixMatchSectionalConfigInterface,
    PlaceholderConfigInterface,
    ProductAddonsConfigInterface,
    ProductAddonsPopupConfigInterface,
    StandardConfigInterface,
    VolumeConfigInterface,
} from "../apps/Bundles/Types";

export interface GlobalSettingsInterface {
    general_settings: StandardConfigInterface["general_settings"];
    design_settings_volume: VolumeConfigInterface["bundles_design"];
    bundle_settings_volume: VolumeConfigInterface["bundles_settings"];
    design_settings_standard: StandardConfigInterface["bundles_design"];
    bundle_settings_standard: StandardConfigInterface["bundles_settings"];
    design_settings_bxgy: BxgyConfigInterface["bundles_design"];
    bundle_settings_bxgy: BxgyConfigInterface["bundles_settings"];
    design_settings_mixmatch: MixMatchConfigInterface["bundles_design"];
    design_settings_mixmatch_sectional: MixMatchSectionalConfigInterface["bundles_design"];
    bundle_settings_mixmatch: MixMatchConfigInterface["bundles_settings"];
    bundle_settings_mixmatch_sectional: MixMatchSectionalConfigInterface["bundles_settings"];
    bundle_settings_fbt: FBTConfigInterface["bundles_settings"];
    design_settings_fbt: FBTConfigInterface["bundles_design"];
    bundle_settings_bundle_builder: BundleBuilderConfigInterface["bundles_settings"];
    design_settings_bundle_builder: BundleBuilderConfigInterface["bundles_design"];
    bundle_settings_bb_placeholder: PlaceholderConfigInterface["bundles_settings"];
    design_settings_bb_placeholder: PlaceholderConfigInterface["bundles_design"];
    design_settings_product_add_on: ProductAddonsConfigInterface["bundles_design"];
    bundle_settings_product_add_on: ProductAddonsConfigInterface["bundles_settings"];
    design_settings_product_add_on_popup: ProductAddonsPopupConfigInterface["bundles_design"];
    bundle_settings_product_add_on_popup: ProductAddonsPopupConfigInterface["bundles_settings"];
    design_settings_buy_n: BuyNConfigInterface["bundles_design"];
    bundle_settings_buy_n: BuyNConfigInterface["bundles_settings"];
}

export type GlobalSettingsKeys =
    | "general_settings"
    | "design_settings_volume"
    | "bundle_settings_volume"
    | "design_settings_standard"
    | "bundle_settings_standard"
    | "design_settings_bxgy"
    | "bundle_settings_bxgy"
    | "design_settings_mixmatch"
    | "design_settings_mixmatch_sectional"
    | "bundle_settings_mixmatch"
    | "bundle_settings_mixmatch_sectional"
    | "bundle_settings_fbt"
    | "design_settings_fbt"
    | "design_settings_product_add_on"
    | "bundle_settings_product_add_on"
    | "design_settings_product_add_on_popup"
    | "bundle_settings_product_add_on_popup"
    | "bundle_settings_buy_n"
    | "design_settings_buy_n"
    | "bundle_settings_bb_placeholder"
    | "design_settings_bb_placeholder";

const useGlobalSettingsHook = () => {
    const [loading, setLoading] = useState(true);
    const [globalSettings, setGlobalSettings] = useState<GlobalSettingsInterface | null>(null);

    const fetchSettings = useCallback(async () => {
        setLoading(true);

        const res = await getData({ url: endPoints.getBundlesSettings });
        if (res.status == 200) {
            if (res.data.bundleGlobalSettings) {
                setGlobalSettings({
                    ...res.data.bundleGlobalSettings,
                });
            } else {
                setGlobalSettings(null);
            }
            setLoading(false);
        } else {
            setGlobalSettings(null);
        }
        setLoading(false);
    }, []);
    return { globalSettings, setGlobalSettings, loading, fetchSettings };
};

export default useGlobalSettingsHook;
